import {membersPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {Routes} from '../../../../../../commons/enums'
import {useMembersPageActions} from '../../../hooks/runtime'
import {EventLink} from '../../styled-components/event-link'
import {GoToOrderButtonProps} from './interfaces'

export const GoToOrderButton = ({event}: GoToOrderButtonProps) => {
  const {t} = useTranslation()
  const {internalNavigate} = useMembersPageActions()

  return (
    <EventLink
      secondary
      mobile
      as="a"
      onClick={() => internalNavigate({route: Routes.ORDER_LIST, params: {event}})}
      data-hook={DH.BUTTON_SHOW_ORDERS}
    >
      {t('events.buttons.order-details')}
    </EventLink>
  )
}
